// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xxDb4LRjeSuqkY2gOXhp {
  font-family: Noto Sans;
  font-size: 11.27px;
  font-weight: 400
}

.qMpTayaSMexmm32pnJsN {
  font-family: Noto Sans;
  font-size: 11.27px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}

.Fb3zGjxj9Q3911lVyjOV {
  font-family: Noto Sans;
  font-size: 16px;
  font-weight: 600
}

.wnrUO8wz4N8Y9iokYyYu {
  font-family: Noto Sans;
  font-size: 28px;
  font-weight: 600
}

.NQL4TwYicBKBe9j4oRY4 {
  position: relative;
  height: 168px;
  overflow: hidden;
  border-radius: 5px;
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.MxMNe2UE3vJbSUY9LNmR {
  position: relative;
  height: 168px;
  overflow: hidden;
  border-radius: 5px;
  background-color: transparent
}

.top9Ddw8_6zyYa5TXYG6 {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat
}

.TAvIeRuTZOUJYLkBA1Jd {
  display: flex;
  height: 41px;
  width: 39px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: linear-gradient(
    142.42deg,
    rgba(255, 255, 255, 0.4) 6.93%,
    rgba(255, 255, 255, 0.1) 66.93%
  )
}

.qZ8K0YW2NYZnrPHLwYNM {
  display: flex;
  height: 41px;
  width: 39px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: linear-gradient(180deg, #9899ff 0%, #5859e4 100%)
}

.wnrUO8wz4N8Y9iokYyYu {
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 700
}

.setmEn6cdQTbkSU5oHEi {
  margin-top: 0.5rem;
  display: flex;
  height: 20px;
  width: 116px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  font-family: Noto Sans;
  font-size: 0.75rem;
  line-height: 1rem;
  font-size: 12px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  background: linear-gradient(
    142.42deg,
    rgba(255, 255, 255, 0.4) 6.93%,
    rgba(255, 255, 255, 0.1) 66.93%
  )
}

.nWR2bXeYtT9F9krNuPPF {
  display: flex;
  align-items: center;
  gap: 0.75rem
}

.zZla_RIITyjCHhl0kOpV {
  display: flex;
  flex-direction: column
}

.YNt8YuzE_Oy6B3_wc5wz {
  margin-top: 30px
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Card/Card.module.css"],"names":[],"mappings":"AACE;EAAA,sBAA0C;EAA1C,kBAA0C;EAA1C;AAA0C;;AAI1C;EAAA,sBAAwD;EAAxD,kBAAwD;EAAxD,gBAAwD;EAAxD,oBAAwD;EAAxD;AAAwD;;AAIxD;EAAA,sBAAqC;EAArC,eAAqC;EAArC;AAAqC;;AAIrC;EAAA,sBAAiC;EAAjC,eAAiC;EAAjC;AAAiC;;AAIjC;EAAA,kBAAiF;EAAjF,aAAiF;EAAjF,gBAAiF;EAAjF,kBAAiF;EAAjF,6BAAiF;EAAjF,oBAAiF;EAAjF;AAAiF;;AAIjF;EAAA,kBAAsE;EAAtE,aAAsE;EAAtE,gBAAsE;EAAtE,kBAAsE;EAAtE;AAAsE;;AAItE;EAAA,sBAAsC;EAAtC,2BAAsC;EAAtC;AAAsC;;AAItC;EAAA,aAAuE;EAAvE,YAAuE;EAAvE,WAAuE;EAAvE,mBAAuE;EAAvE,uBAAuE;EAAvE,kBAAuE;EACvE;;;;;AADuE;;AASvE;EAAA,aAAuE;EAAvE,YAAuE;EAAvE,WAAuE;EAAvE,mBAAuE;EAAvE,uBAAuE;EAAvE,kBAAuE;EACvE;AADuE;;AAKvE;EAAA,iBAAyB;EAAzB,iBAAyB;EAAzB;AAAyB;;AAIzB;EAAA,kBAAgJ;EAAhJ,aAAgJ;EAAhJ,YAAgJ;EAAhJ,YAAgJ;EAAhJ,mBAAgJ;EAAhJ,uBAAgJ;EAAhJ,kBAAgJ;EAAhJ,sBAAgJ;EAAhJ,kBAAgJ;EAAhJ,iBAAgJ;EAAhJ,eAAgJ;EAAhJ,gBAAgJ;EAAhJ,oBAAgJ;EAAhJ,mDAAgJ;EAChJ;;;;;AADgJ;;AAShJ;EAAA,aAA8B;EAA9B,mBAA8B;EAA9B;AAA8B;;AAI9B;EAAA,aAAoB;EAApB;AAAoB;;AAIpB;EAAA;AAAgB","sourcesContent":[".cardTitle {\n  @apply text-[11.27px] font-body font-inter;\n}\n\n.darkCardTitle {\n  @apply text-[11.27px] font-body font-inter text-gray-400;\n}\n\n.subTitle {\n  @apply text-button font-h4 font-inter;\n}\n\n.value {\n  @apply font-h4 text-h3 font-inter;\n}\n\n.card {\n  @apply rounded-[5px] h-[168px] relative overflow-hidden bg-transparent text-white;\n}\n\n.cardDark {\n  @apply rounded-[5px] h-[168px] relative overflow-hidden bg-transparent;\n}\n\n.withBg {\n  @apply bg-cover bg-center bg-no-repeat;\n}\n\n.iconWrapper {\n  @apply w-[39px] h-[41px] flex items-center justify-center rounded-[5px];\n  background: linear-gradient(\n    142.42deg,\n    rgba(255, 255, 255, 0.4) 6.93%,\n    rgba(255, 255, 255, 0.1) 66.93%\n  );\n}\n\n.darkIconWrapper {\n  @apply w-[39px] h-[41px] flex items-center justify-center rounded-[5px];\n  background: linear-gradient(180deg, #9899ff 0%, #5859e4 100%);\n}\n\n.value {\n  @apply text-2xl font-bold;\n}\n\n.footer {\n  @apply text-xs text-white w-[116px] h-[20px] rounded-[5px] flex justify-center items-center mt-2 font-inter text-dashboardSub font-dashboardMain;\n  background: linear-gradient(\n    142.42deg,\n    rgba(255, 255, 255, 0.4) 6.93%,\n    rgba(255, 255, 255, 0.1) 66.93%\n  );\n}\n\n.headerRow {\n  @apply flex items-center gap-3;\n}\n\n.textWrapper {\n  @apply flex flex-col;\n}\n\n.footerOptions {\n  @apply mt-[30px];\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardTitle": `xxDb4LRjeSuqkY2gOXhp`,
	"darkCardTitle": `qMpTayaSMexmm32pnJsN`,
	"subTitle": `Fb3zGjxj9Q3911lVyjOV`,
	"value": `wnrUO8wz4N8Y9iokYyYu`,
	"card": `NQL4TwYicBKBe9j4oRY4`,
	"cardDark": `MxMNe2UE3vJbSUY9LNmR`,
	"withBg": `top9Ddw8_6zyYa5TXYG6`,
	"iconWrapper": `TAvIeRuTZOUJYLkBA1Jd`,
	"darkIconWrapper": `qZ8K0YW2NYZnrPHLwYNM`,
	"footer": `setmEn6cdQTbkSU5oHEi`,
	"headerRow": `nWR2bXeYtT9F9krNuPPF`,
	"textWrapper": `zZla_RIITyjCHhl0kOpV`,
	"footerOptions": `YNt8YuzE_Oy6B3_wc5wz`
};
export default ___CSS_LOADER_EXPORT___;
